import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import DashboardContainerNew from './DashboardContainerNew';
import { BoundaryWrapper } from './BoundaryWrapper';

const DashboardRoute = ({
  component: Component,
  viewName,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => (
      <DashboardContainerNew>
        <BoundaryWrapper>
          <Component {...props} />
        </BoundaryWrapper>
      </DashboardContainerNew>
    )}
  />
);

DashboardRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
  ]).isRequired,
  viewName: PropTypes.string.isRequired,
};

export default DashboardRoute;
